import { Injectable } from "@angular/core"
import { environment } from "../../../../environments/environment"
import { AppService } from "src/app/core/services/app.service"
import { HttpClient, HttpParams } from "@angular/common/http"
import {
  CustomURLEncoder,
  isNullOrUndefined,
} from "src/app/core/helpers/http-params-extensions"

@Injectable({
  providedIn: "root",
})
export class SchoolClassService {
  private post_group_url: string
  private post_group_import_url: string
  private get_group_id_url: string
  private get_group_paginate_url: string
  private put_group_id_url: string
  private post_credentials_url: string
  private post_credentials_for_profiles: string
  private buildUrls(schoolClassUrl: string) {
    this.post_group_url =
      schoolClassUrl + environment.endpointSchoolClass.routes.post_group
    this.post_group_import_url =
      schoolClassUrl + environment.endpointSchoolClass.routes.post_group_import
    this.get_group_id_url =
      schoolClassUrl + environment.endpointSchoolClass.routes.get_group_id
    this.get_group_paginate_url =
      schoolClassUrl + environment.endpointSchoolClass.routes.get_group_paginate
    this.put_group_id_url =
      schoolClassUrl + environment.endpointSchoolClass.routes.put_group_id
    this.post_credentials_url =
      schoolClassUrl +
      environment.endpointSchoolClass.routes.post_credentials_group
    this.post_credentials_for_profiles =
      schoolClassUrl +
      environment.endpointSchoolClass.routes.post_credentials_for_profiles
  }

  constructor(private httpClient: HttpClient, private appService: AppService) {
    this.buildUrls(environment.endpointSchoolClass.url)
  }

  postFile() {
    return this.post_group_import_url
  }

  postGroup(group: any) {
    if (group["published"] === true) {
      group["published"] = 1
    } else {
      group["published"] = 0
    }
    return this.httpClient.post(this.post_group_url, group)
  }

  getPagginate(group: any) {
    let params = new HttpParams({ encoder: new CustomURLEncoder() })

    params = params.set("itensPerPage", String(group.table.itensPerPage))
    params = params.set("askPage", String(group.table.askPage))

    if (!isNullOrUndefined(group.schoolId)) {
      params = params.set("schoolId", String(group.schoolId))
    }
    if (!isNullOrUndefined(group.groupCode)) {
      params = params.set("groupCode", String(group.groupCode))
    }
    if (!isNullOrUndefined(group.groupName)) {
      params = params.set("groupName", String(group.groupName))
    }
    if (!isNullOrUndefined(group.status)) {
      params = params.set("status", String(group.status))
    }
    if (!isNullOrUndefined(group.table.orderByFilter)) {
      params = params.set("orderByFilter", String(group.table.orderByFilter))
    }
    if (!isNullOrUndefined(group.table.isDesc)) {
      params = params.set("isDesc", String(group.table.isDesc))
    }
    if (!isNullOrUndefined(group.tags)) {
      group.tags.map((obj, index) => {
        params = params.set(`tagsName[${index}]`, obj.tagKey)
      })
    }

    return this.httpClient.get(this.get_group_paginate_url, { params })
  }

  getOneGroup(id: string) {
    return this.httpClient.get(this.get_group_id_url.replace("{groupId}", id))
  }

  lexImportUrl(schoolId: string) {
    return `${environment.endpointSchoolClass.url}/api/v1/usergroup/leximport/${schoolId}`
  }

  putGroup(group: any) {
    if (group["published"] === true) {
      group["published"] = 1
    } else {
      group["published"] = 0
    }
    return this.httpClient.put(
      this.put_group_id_url.replace("{groupId}", group.id),
      group
    )
  }

  requestCredentials(classesIds: string[]) {
    return this.httpClient.post(this.post_credentials_url, classesIds)
  }

  requestCredentialsForProfiles(credentialRequest) {
    return this.httpClient.post(
      this.post_credentials_for_profiles,
      credentialRequest
    )
  }
}
